
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import ChatSection from '@/components/home/ChatSection';
import { NewsPreview } from '@/components/news/NewsPreview';
import SearchBar from '@/components/search/SearchBar';
import NotificationSection from '@/components/home/NotificationSection';
import LatestPostsSection from '@/components/home/LatestPostsSection';
import LatestCommentsSection from '@/components/home/LatestCommentsSection';
import BoardPreviewsSection from '@/components/home/BoardPreviewsSection';
import CommunityBoardPreview from '@/components/home/CommunityBoardPreview';
import { useIsMobile } from '@/hooks/use-mobile';
import { SEO } from '@/components/seo/SEO';

const Index = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="라스베가스 한인 커뮤니티 - VegasKFam"
        description="라스베가스 한인들을 위한 종합 정보 커뮤니티. 구인구직, 부동산, 사고팔고, 비즈니스, 여행 정보를 제공합니다."
        keywords="라스베가스 한인, 라스베가스 한인 커뮤니티, 라스베가스 한인타운, 한인 모임, 라스베가스 한인회, 라스베가스 교민, 라스베가스 한인 정보"
        ogUrl="https://vegaskfam.com"
      />
      <Header />
      
      <main className="flex-1 container mx-auto py-2 px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="md:col-span-3">
            <ChatSection />
            {isMobile && <div className="mt-3"><NotificationSection /></div>}
            {isMobile && <div className="mt-3"><LatestPostsSection /></div>}
            <div className="mt-3"></div>
            {/* 위치를 변경함: CommunityBoardPreview를 먼저, BoardPreviewsSection을 그 다음 (배포 갱신용 주석 변경) */}
            <CommunityBoardPreview />
            <BoardPreviewsSection />
            {/* 최신글(게시글) 섹션 가운데 영역에서 제거됨 */}
            <NewsPreview />
          </div>

          <div className="md:col-span-1 space-y-4">
            <SearchBar />
            {!isMobile && <NotificationSection />}
            {/* 사이드바 공지사항과 최신글 사이에 영화 포스터 이미지 추가 */}
            {!isMobile && (
              <div>
                <img 
                  src="https://nfblekrijwuomdzxypfi.supabase.co/storage/v1/object/public/business_images//poster.png"
                  alt="Poster"
                  className="w-full rounded-lg shadow-sm my-2"
                />
              </div>
            )}
            {!isMobile && <LatestPostsSection />}
            {!isMobile && <LatestCommentsSection />}
            {/* SiteStatistics component removed as requested */}
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Index;
